/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { getAllRouteParams } from '@app/common/utils/router';
import { clusterList, currentCluster, routerState, selectRouteParam } from '@app/core/ngrx/app.selectors';
import { AppState } from '@app/core/types';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { isCluster3x } from '@shared/domain/cluster';

export const routeClusterUserId = selectRouteParam('userId');
export const selectAllChildrenRouteParams = createSelector(routerState, (router) =>
  router?.state?.root ? getAllRouteParams(router.state.root) : {},
);
export const selectAllChildrenRouteParam = (name: string) =>
  createSelector(selectAllChildrenRouteParams, (params) => params[name]);
export const routeContextActionClusterId = selectAllChildrenRouteParam('contextActionClusterId');

export const clusterUsersSelector = createFeatureSelector<AppState['clusterUsers']>('clusterUsers');
export const routeClusterUsers = createSelector(
  routeContextActionClusterId,
  clusterUsersSelector,
  (clusterId, clusterUsers) => (clusterId ? clusterUsers.get(clusterId) : undefined),
);
export const routeClusterUser = createSelector(routeClusterUserId, routeClusterUsers, (userId, clusterUsers) =>
  clusterUsers?.find((user) => user.id === userId),
);

export const routeContextActionCluster = createSelector(
  clusterList,
  routeContextActionClusterId,
  (clusters, routeClusterId) => (!routeClusterId ? null : clusters.find((cluster) => cluster.id === routeClusterId)),
);

export const availableContextActionClusterIds = createSelector(
  clusterList,
  currentCluster,
  (clusters, currentCluster) => new Set([...clusters.map(({ id }) => id), currentCluster]),
);

export const isRouteContextActionCluster3x = createSelector(
  routeContextActionCluster,
  (cluster) => !!cluster && isCluster3x(cluster),
);
